import React, { RefObject } from "react";
import IFormDefinition from "../../../interfaces/IFormDefinition";
import SchemaForm from "../../schema/SchemaForm";

interface DefaultNoteFormProps {
    formData: { [key: string]: any }
    onChange: (values: { [key: string]: any }) => void;

    schema: IFormDefinition["schema"];

    onSubmit: (values: { [key: string]: any }) => void;
    submitButton: RefObject<HTMLButtonElement>;
};

export const DefaultNoteForm: React.FC<DefaultNoteFormProps> = ({
    formData,
    onChange,

    schema,
    onSubmit: submit,
    submitButton,
}) => {
    return (
        <SchemaForm
            {...schema}
            formData={formData}
            onSubmit={(formData) => submit(formData)}
            onChange={(form) => onChange(form.formData)}
            ErrorList={() => null}
        // ErrorList={(props) => <Fragment>{JSON.stringify(props)}</Fragment>}
        >
            <button ref={submitButton} type="submit" style={{ display: "none", opacity: 0 }} />
        </SchemaForm>
    );
};
